<template>
  <div class="flex justify-between items-center mb-8">
    <h1 class="text-3xl font-bold text-orfBlue-100">Banner Test</h1>
    <button class="rounded text-sm bg-green-600 p-3 text-white hover:bg-green-700 flex items-center mx-1" @click="download"><HeroIcon name="download" class="w-4 mr-1"/> Herunterladen (PNG)</button>
    <button class="rounded text-sm bg-green-600 p-3 text-white hover:bg-green-700 flex items-center mx-1" @click="store"><HeroIcon name="download" class="w-4 mr-1"/> store (PNG)</button>
  </div>
  <div class="flex flex-col lg:flex-row justify-between">
    <div class="flex flex-col bg-white shadow-xl rounded w-full lg:w-1/3 p-4 my-2 lg:mx-2 md:my-0">
      <div class="text-gray-700 font-bold text-lg">
        Allgemein:
      </div>
      <hr class="my-4"/>
      <div class="w-full flex justify-between items-center">
        <div class="mr-3">Format: </div>
        <select-input v-model="selectedFormat" pre="900x450" class="my-2 w-40 flex items-center justify-between">
          <option value="900x450">900x450</option>
          <option value="900x225">900x225</option>
          <option value="900x90">900x90</option>
          <option value="600x75">600x75</option>
          <option value="300x150">300x150</option>
          <option value="300x50">300x50</option>
        </select-input>
      </div>
      <div class="flex my-2 w-full justify-between items-center">
        <div class="mr-3">Hintergrundfarbe: </div>
        <input id="color" v-model="configRect.fill" type="color" :style="['background: #cbd5e1']" class="rounded h-11 w-40 cursor-pointer">
      </div>
    </div>
    <div class="flex flex-col bg-white shadow-xl rounded w-full lg:w-2/3 p-4 my-2 lg:mx-2 md:my-0">
      <div class="text-gray-700 font-bold text-lg">
        Elemente:
      </div>
      <hr class="my-4"/>
      <form @submit.prevent="addText" class="flex my-2 w-full justify-between items-center">
        <div class="mr-3 ">Text: </div>
        <text-input v-model="form.text" required type="text" :style="['color: ' + form.textColor, form.fontStyle.indexOf('italic') != -1 ? 'fontStyle: italic' : '', form.fontStyle.indexOf('bold') != -1 ? 'fontWeight: bold' : '']" class="flex-grow h-11 flex items-center" placeholder="Beispiel: ORF Enterprise ..."/>
        <Tooltip text="Fett">
          <div :class="['rounded bg-gray-300 p-3 hover:bg-gray-400 hover:text-white flex font-bold items-center mx-1 cursor-pointer', form.fontStyle.indexOf('bold') != -1 ? 'bg-gray-400 text-white' : '' ]" @click="toggleFormFontStyle('bold')"><HeroIcon name="bold" class="h-4"/></div>
        </Tooltip>
        <Tooltip text="Kursiv">
          <div :class="['rounded bg-gray-300 p-3 hover:bg-gray-400 hover:text-white flex italic font-bold items-center mx-1 cursor-pointer', form.fontStyle.indexOf('italic') != -1 ? 'bg-gray-400 text-white' : '' ]" @click="toggleFormFontStyle('italic')"><HeroIcon name="italic" class="h-4"/></div>
        </Tooltip>
        <Tooltip text="Schriftfarbe">
          <input id="text-color" v-model="form.textColor" type="color" :style="'background: #cbd5e1'" class="rounded mx-2 w-20 h-11 cursor-pointer">
        </Tooltip>
        <button type="submit" class="rounded p-3 bg-gray-300 text-sm hover:bg-gray-400 hover:text-white flex items-center whitespace-nowrap w-40 mx-1"><HeroIcon name="add" icon-custom-icon class="w-4 mr-1"/>Text hinzufügen</button>
      </form>
      <form @submit.prevent="addImage" class="flex my-2 w-full justify-between items-center">
        <div class="mr-3">Bild: </div>
        <file-input v-model="form.image" required class="flex-grow whitespace-nowrap mr-2"/>
        <button type="submit" class="rounded p-3 bg-gray-300 text-sm hover:bg-gray-400 hover:text-white flex items-center whitespace-nowrap w-40 mx-1"><HeroIcon name="add" icon-custom-icon class="w-4 mr-1"/>Bild hinzufügen</button>
      </form>
    </div>
  </div>
  <div class="my-4 flex flex-col items-center">
    <div class="h-10 my-2 flex items-center w-full justify-between">
      <button v-if="selectedShapeName" class="rounded bg-gray-300 p-3 hover:bg-gray-400 hover:text-white flex items-center mx-1" @click="moveToForeground(selectedShapeName)"><HeroIcon name="circle-up" class="w-4 mr-1"/>In den Vordergrund</button>
      <div v-if="selectedShapeName && getItemFromName(selectedShapeName).type == 'text'" class="flex justify-center">
        <div class="flex items-center rounded bg-gray-300 px-3 py-1 hover:bg-gray-400 hover:text-white mx-1 cursor-pointer">
          <label for="color" class="mr-1 w-full cursor-pointer">Schriftfarbe: </label>
          <input id="color" v-model="getItemFromName(selectedShapeName).fill" type="color" :style="['background: transparent']" class="rounded-full h-8 w-9 cursor-pointer">
        </div>
        <button :class="['rounded bg-gray-300 p-3 hover:bg-gray-400 hover:text-white flex font-bold items-center mx-1 cursor-pointer', getItemFromName(selectedShapeName).fontStyle.indexOf('bold') != -1 ? 'bg-gray-400 text-white' : '' ]" @click="toggleFontStyle('bold')"><HeroIcon name="bold" class="h-4"/></button>
        <button :class="['rounded bg-gray-300 p-3 hover:bg-gray-400 hover:text-white italic flex font-bold items-center mx-1 cursor-pointer', getItemFromName(selectedShapeName).fontStyle.indexOf('italic') != -1 ? 'bg-gray-400 text-white' : '' ]" @click="toggleFontStyle('italic')"><HeroIcon name="italic" class="h-4"/></button>
      </div>
      <button v-if="selectedShapeName" class="rounded bg-gray-300 p-3 hover:bg-gray-400 hover:text-red-700 flex items-center mx-1" @click="removeShape(selectedShapeName)"><HeroIcon name="trash" icon-mini class="w-4 mr-1"/> Entfernen</button>
    </div>
    <v-stage ref="stage" :config="configKonva" @mousedown="handleStageMouseDown" @touchstart="handleStageMouseDown">
      <v-layer ref="layer">
        <v-rect :config="configRect"/>
        <template v-for="item in items" :key="item.id">
          <v-image v-if="item.type == 'image'"
                   :config="item"
                   @transformend="handleTransformEnd" @dragend="handleDragEnd"/>
          <v-text v-if="item.type == 'text'" :config="item" @transformend="handleTransformEnd" @dragend="handleDragEnd"/>
        </template>
        <v-transformer ref="transformer" />
      </v-layer>
    </v-stage>
  </div>
  <div class="my-4">
    <div class="text-gray-700 font-bold text-lg">
      Elemente:
    </div>
  </div>
  <div class="flex">
    <div v-for="item in items" :key="item.id" class="flex flex-col bg-white shadow-xl rounded w-full lg:w-1/5 p-4 my-2 lg:mx-2 md:my-0">
      <div v-if="item.type == 'image'" class="flex flex-col items-center h-full">
        <div class="font-bold mb-2 h-5 flex items-center w-full">
          <div class="w-16 flex items-center">
            <Tooltip text="Auswählen">
              <HeroIcon name="search" custom-icon @click="selectShape(item.name)" class="w-5 mr-1 transform cursor-pointer hover:scale-125 hover:fill-orfBlue-100"/>
            </Tooltip>
            <Tooltip text="In den Vordergrund">
              <HeroIcon name="circle-up" @click="moveToForeground(item.name)" class="w-5 mr-1 transform cursor-pointer hover:scale-125 hover:fill-orfBlue-100"/>
            </Tooltip>
          </div>
          <div class="flex-grow text-center">
            Bild
          </div>
          <div class="w-16 flex items-center justify-end">
            <Tooltip text="Zurücksetzen">
              <HeroIcon name="arrow-path" @click="reset(item.name)" class="w-5 mr-1 group-hover:fill-orfBlue-100 transition-all 0.5s ease-in-out transform cursor-pointer hover:scale-125 hover:fill-orfBlue-100"/>
            </Tooltip>
            <Tooltip text="Entfernen">
              <HeroIcon name="trash" icon-mini class="w-4 mr-1 cursor-pointer transform fill-red-600 hover:scale-125" @click="removeShape(item.name)"/>
            </Tooltip>
          </div>
        </div>
        <div class="flex-grow flex justify-center items-center">
          <img :src="item.name" class="shadow-inner bg-gray-200"/>
        </div>
      </div>
      <div v-if="item.type == 'text'" class="flex flex-col items-center h-full">
        <div class="font-bold mb-2 h-5 flex items-center w-full">
          <div class="w-16 flex items-center">
            <Tooltip text="Auswählen">
              <HeroIcon name="search" custom-icon @click="selectShape(item.name)" class="w-5 mr-1 group-hover:fill-orfBlue-100 transition-all 0.5s ease-in-out  transform cursor-pointer hover:scale-125 hover:fill-orfBlue-100"/>
            </Tooltip>
            <Tooltip text="In den Vordergrund">
              <HeroIcon name="circle-up" @click="moveToForeground(item.name)" class="w-5 mr-1 group-hover:fill-orfBlue-100 transition-all 0.5s ease-in-out  transform cursor-pointer hover:scale-125 hover:fill-orfBlue-100"/>
            </Tooltip>
          </div>
          <div class="flex-grow text-center">
            Text
          </div>
          <div class="w-16 flex items-center justify-end">
            <Tooltip text="Zurücksetzen">
              <HeroIcon name="arrow-path" @click="reset(item.name)" class="w-5 mr-1 group-hover:fill-orfBlue-100 transition-all 0.5s ease-in-out transform cursor-pointer hover:scale-125 hover:fill-orfBlue-100"/>
            </Tooltip>
            <Tooltip text="Entfernen">
              <HeroIcon name="trash" icon-mini class="w-5 mr-1 cursor-pointer transform fill-red-600 hover:scale-125" @click="removeShape(item.name)"/>
            </Tooltip>
          </div>
        </div>
        <div class="flex-grow flex justify-center items-center max-w-full">
          <div class="shadow-inner p-2 bg-gray-200 max-w-full">{{item.text}}</div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import HeroIcon from '@/Shared/HeroIcon.vue'
import SelectInput from '@/Shared/SelectInput'
import Tooltip from '@/Shared/Tooltip'

export default {
  components: {
    Tooltip,
    SelectInput,
    HeroIcon,
    FileInput,
    TextInput,
  },
  props: {
    data: String,
    initialBannerData: Object
  },
  data() {
    return {
      selectedFormat: "900x450",
      items: [],
      selectedShapeName: null,
      configKonva: {
        width: 900,
        height: 450,
      },
      configRect: {
        width: 900,
        height: 450,
        fill: '#000000',
      },
      bannerData: this.initialBannerData ? this.initialBannerData : "{'test': {'name': 'testname', 'salery': 'none'}}",
      isDragging: false,
      form: this.$inertia.form({
        image: null,
        text: null,
        textColor: '#ffffff',
        fontStyle: '',
      }),
    }
  },
  watch: {
    'selectedFormat': {
      handler: function(newValue) {
        this.configKonva.height = parseInt(newValue.split('x')[1])
        this.configKonva.width = parseInt(newValue.split('x')[0])
        this.configRect.height = parseInt(newValue.split('x')[1])
        this.configRect.width = parseInt(newValue.split('x')[0])
        const transformerNode = this.$refs.transformer.getNode();
        const stage = transformerNode.getStage();
        const items = stage.children[0].children
        items.forEach((item) => {
          if (item._id != 3 && item._id != 4){
            item.absolutePosition({
              x: 0,
              y: 0,
            })
            item.scaleX(0.5);
            item.scaleY(0.5);
          }
        })
      },
      deep: true
    },
  },
  mounted() {
    //this.createShape('image', null, '/img/Enterprise_quer_4C_HG%20blau.png')
    //this.createShape('text', 'Buchen Sie Erfolg!', null, '#ffffff', '')
    let test = JSON.parse(this.initialBannerData);
    console.log(test);
  },
  methods: {
    /*
    setPosition(name){
      const mousePos = this.$refs.stage.getNode();
      const item = mousePos.findOne("." + name);
      const positions = item.absolutePosition();
      const listItem = this.getItemFromName(name);
      listItem.x = positions.x
      listItem.y = positions.y
    },*/
    store(){
      let canvasState = {
        'configKonva': this.configKonva,
        'configRect': this.configRect,
        'items': this.items,
      }
      console.log(canvasState);
      this.$inertia.put('banners', canvasState);
    },
    reset(name){
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const selectedNode = stage.findOne('.' + name);
      selectedNode.absolutePosition({
        x: 0,
        y: 0,
      })
      selectedNode.scaleX(0.5);
      selectedNode.scaleY(0.5);
      selectedNode.moveToTop()
    },
    getPositionFromItem(name, position){
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const selectedNode = stage.findOne('.' + name);
      return selectedNode.absolutePosition().x
    },
    toggleFormFontStyle(style){
      this.form.fontStyle = this.form.fontStyle.indexOf(style) == -1 ? style + ' ' + this.form.fontStyle + ' '  : this.form.fontStyle.replace(style, '')
    },
    toggleFontStyle(style){
      const item = this.getItemFromName(this.selectedShapeName)
      item.fontStyle = item.fontStyle.indexOf(style) == -1 ? style + ' ' + item.fontStyle + ' '  : item.fontStyle.replace(style, '')
    },
    getItemFromName(name){
      return this.items.find(x => x.name == name)
    },
    download(){
      let link = document.createElement('a')
      link.download = 'Banner.png'
      link.href = document.getElementsByTagName('canvas')[0].toDataURL()
      link.click();
    },
    addText(){
      this.createShape('text', this.form.text, null, this.form.textColor, this.form.fontStyle)
      this.form.reset();
    },
    addImage(){
      this.form.post('/uploadImage', {
        preserveScroll: true,
        onSuccess: (e) => {
          this.createShape('image', null, e.props.data)
          this.form.reset()
        },
      })
    },
    createShape(type, text, src, fill, fontStyle){
      if (type == 'image'){
        let img = new Image();
        img.src = src;
        let config = {
          type: 'image',
          image: img,
          name: src,
          rotation: 0,
          scaleX: 1,
          x: 0,
          y: 0,
          scaleY: 1,
          draggable: true,
        }
        this.items.push(config)
      }
      if (type == 'text'){
        let config = {
          type: 'text',
          name: 'img' + this.items.filter(function( obj ) {return obj.type == 'text'}).length + 1,
          text: text,
          rotation: 0,
          scaleX: 1,
          scaleY: 1,
          fontSize: 40,
          fontStyle: fontStyle,
          x: 0,
          y: 0,
          draggable: true,
          fill: fill ? fill : '#ffffff',
        }
        this.items.push(config)
      }
    },
    selectShape(name){
      this.selectedShapeName = name;
      this.updateTransformer(name);
    },
    handleDragEnd(e) {
      const rect = this.items.find(
        (r) => r.name === this.selectedShapeName
      )
      console.log(e.target.x())
      console.log(e.target.y())
      rect.x = e.target.x();
      rect.y = e.target.y();
      rect.rotation = e.target.rotation();
      rect.scaleX = e.target.scaleX();
      rect.scaleY = e.target.scaleY();
    },
    handleTransformEnd(e) {
      // shape is transformed, let us save new attrs back to the node
      // find element in our state
      const rect = this.items.find(
        (r) => r.name === this.selectedShapeName
      );
      // update the state
      console.log(e.target.x())
      console.log(e.target.y())
      rect.x = e.target.x();
      rect.y = e.target.y();
      rect.rotation = e.target.rotation();
      rect.scaleX = e.target.scaleX();
      rect.scaleY = e.target.scaleY();

    },
    handleStageMouseDown(e) {
      // filter native events
      if (!e.evt) {
        return;
      }
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.selectedShapeName = '';
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
        e.target.getParent().className === 'Transformer';
      if (clickedOnTransformer) {
        return;
      }

      // find clicked rect by its name
      const name = e.target.name();
      const rect = this.items.find((r) => r.name === name);
      if (rect) {
        this.selectedShapeName = name;
      } else {
        this.selectedShapeName = '';
      }
      this.updateTransformer();
    },
    updateTransformer(name) {
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const selectedShapeName = name || this.selectedShapeName;
      const selectedNode = stage.findOne('.' + selectedShapeName);
      // do nothing if selected node is already attached
      if (selectedNode === transformerNode.node()) {
        return;
      }

      if (selectedNode) {
        transformerNode.moveToTop()
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
    },
    removeShape(name) {
      if (confirm('Bist du dir sicher?')){
        this.items = this.items.filter(function( obj ) {
          return obj.name != name;
        });
        this.selectedShapeName = null
        this.updateTransformer()
      }
    },
    moveToForeground(name) {
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const selectedNode = stage.findOne('.' + name);
      selectedNode.moveToTop()
    },
  },
}

</script>
<style>

input::-webkit-color-swatch {
  border-radius: 0.25rem;
  border: none;
}
</style>

